import { pick } from 'lodash';

export const name = 'Паслухайце, абярыце правільны варыянт вымаўлення';
export const nameShort = 'Абярыце варыянт вымаўлення';
export const bgInTable = '#efcc1b';

export const fields = [
  {
    name: 'correctAnswers',
    default: [],
    label: 'Правільныя адказы',
    component: 'ListNewValues',
  },
  {
    name: 'afterTaskExplanation',
    default: '',
    label: 'Тлумачэнне задання',
    component: 'Textarea',
  },
  {
    name: 'textContent',
    default: '',
    label: 'Змест задання',
    component: 'Input',
  },
  {
    name: 'options',
    default: [],
    label: 'options',
    component: 'ListNewValues',
  },
  {
    name: 'audio',
    default: '',
    label: 'Аўдыёзапісы',
    component: 'AudioInput',
  },
];

export const dataToSend = form => {
  const optionsResult = form.options.reduce((acc, el, index) => {
    acc[index + 1] = el;
    return acc;
  }, {});

  return {
    type: 'listen_phonetics_choice',
    name: form.name,
    tip: form.tip,
    status: form.status,
    additionalData: {
      afterTaskExplanation: form.afterTaskExplanation,
      textContent: form.textContent,
      options: optionsResult,
    },
    correctAnswers: form.correctAnswers,
    audio: form.audio,
  };
};

export const parseData = data => {
  const dataFast = pick(data, ['name', 'status', 'audio', 'tip', 'correctAnswers']);
  const { afterTaskExplanation, textContent, options } = data.additionalData;
  return {
    ...dataFast,
    afterTaskExplanation,
    options: Object.values(options || {}),
    textContent,
  };
};
